import { render } from "./FlexBoxDemo.vue?vue&type=template&id=44044a5b&scoped=true"
import script from "./FlexBoxDemo.vue?vue&type=script&lang=js"
export * from "./FlexBoxDemo.vue?vue&type=script&lang=js"

import "./FlexBoxDemo.vue?vue&type=style&index=0&id=44044a5b&lang=scss&scoped=true"

import exportComponent from "/home/gitlab-runner/builds/eAzC_LUi/0/econsultingsistemas/certificadorweb/certificador-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44044a5b"]])

export default __exports__